<template>
	<li :class="{ active : model.active }">
		<a :href="model.url"><i class="fas fa-puzzle-piece"></i>{{model.name}}</a>
		<ul v-if="model.expanded && model.children">
			<schema-tree-item :model="child" v-for="(child,index) in model.children" :key="child.id" />
		</ul>
	</li>
</template>

<script>
import SchemaTreeItem from "@/components/utilities/SchemaTreeItem";
import Vue from 'vue';

export default {
	name: "schema-tree-item",	// WARNING: This means NOTHING. It's how you IMPORT that defines the tag you'll use (import MyComponent ... --> <my-component ... />)
	props: {
		model: Object
	},
	components: { SchemaTreeItem },
};
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/utilities/SchemaTreeItem.vue